import { useColor } from 'hooks';
import { ColorsDark, ColorsLight } from 'libs/ui/theme';

import { SvgIcon } from '../SvgIcon';
import { SvgProps } from '../types';

export const DocumentLinear = ({ size = 24, color, className }: SvgProps) => {
  const defaultColor = useColor({
    dark: ColorsDark.white,
    light: ColorsLight.black,
  });
  color = color || defaultColor;
  return (
    <SvgIcon className={className} size={size}>
      <svg
        color={color}
        fill="none"
        height="20"
        viewBox="0 0 20 20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.5 8.33464C2.5 5.19214 2.5 3.62047 3.47667 2.64464C4.45333 1.6688 6.02417 1.66797 9.16667 1.66797H10.8333C13.9758 1.66797 15.5475 1.66797 16.5233 2.64464C17.4992 3.6213 17.5 5.19214 17.5 8.33464V11.668C17.5 14.8105 17.5 16.3821 16.5233 17.358C15.5467 18.3338 13.9758 18.3346 10.8333 18.3346H9.16667C6.02417 18.3346 4.4525 18.3346 3.47667 17.358C2.50083 16.3813 2.5 14.8105 2.5 11.668V8.33464Z"
          stroke="currentColor"
          strokeWidth="1.2"
        />
        <path
          d="M6.66406 10.0013H13.3307M6.66406 6.66797H13.3307M6.66406 13.3346H10.8307"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="1.2"
        />
      </svg>
    </SvgIcon>
  );
};
